/* eslint-disable no-unused-vars */
import { createAPIHandler, useOFetchRaw } from "@/plugins/ofetch";

const _AuthAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/backoffice/public/auth.js").login>}  */
  login: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/backoffice/public/login`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/backoffice/public/auth.js").getResetPassword>}  */
  getResetPassword: createAPIHandler(
    ([token, query = undefined]) => [
      `/n/api/backoffice/public/resetpassword/${encodeURIComponent(token)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/backoffice/public/auth.js").resetPassword>}  */
  resetPassword: createAPIHandler(
    ([token, body = {}, query = undefined]) => [
      `/n/api/backoffice/public/resetpassword/${encodeURIComponent(token)}`,
      { method: "POST", body, query }
    ]
  ),
};
export { _AuthAPI as AuthAPI };
const _MeAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/backoffice/public/me.js").getCurrentUser>}  */
  getCurrentUser: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/backoffice/public/me`,
      { method: "GET", query }
    ]
  ),
};
export { _MeAPI as MeAPI };
const _MembersAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/backoffice/public/members.js").getMemberQR>}  */
  getMemberQR: createAPIHandler(
    ([memberId, query = undefined]) => [
      `/n/api/backoffice/public/members/${encodeURIComponent(memberId)}/qr`,
      { method: "GET", query }
    ]
  ),
};
export { _MembersAPI as MembersAPI };
const _SettingsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/backoffice/public/settings.js").getSettings>}  */
  getSettings: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/backoffice/public/settings`,
      { method: "GET", query }
    ]
  ),
};
export { _SettingsAPI as SettingsAPI };
